import styled from "styled-components";

import { useAppSelector } from "@sso/hooks/useRedux";
import { selectCurrentUser } from "@sso/store/slices/auth";
import { DrawerGroupType } from "@sso/types";
import { ColumnContainer, Wrapper } from "@sso/ui/FlexBox";
import { Typography } from "@sso/ui/Typography";

import { NavItem } from "./NavItem";

const StyledNavGroup = styled(ColumnContainer)`
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  width: 100%;
  align-items: flex-start;
  &:not(:last-child) {
    border-bottom: 1px solid ${props => props.theme.colors.divider};
  }
`;
interface NavGroupProps {
  navGroupItem: DrawerGroupType;
}

export const NavGroup = ({ navGroupItem }: NavGroupProps) => {
  const user = useAppSelector(selectCurrentUser);
  const userHasAccess = navGroupItem.access?.length
    ? navGroupItem.access.some(role => role === user?.role.roleId.toLocaleLowerCase())
    : true;

  if (!userHasAccess) {
    return null;
  }
  return (
    <StyledNavGroup>
      <Wrapper width="100%" margin="0 0 0.5rem 0">
        <Typography size="1rem" fontWeight={500}>
          {navGroupItem.title}
        </Typography>
        {navGroupItem.caption && (
          <Typography size="0.75rem" fontWeight={500}>
            {navGroupItem.caption}
          </Typography>
        )}
      </Wrapper>
      {navGroupItem.children.map(navItem => (
        <NavItem key={navItem.id} item={navItem} />
      ))}
    </StyledNavGroup>
  );
};
